import * as wasmBindgen from "../wasm/spd";
/**
 * Singlethreaded debug build MmdWasmInstanceType with integrated bullet physics
 *
 * Requirements for use:
 *
 * - Browser that supports WebAssembly
 */
export class MmdWasmInstanceTypeSPD {
    getWasmInstanceInner() {
        return wasmBindgen;
    }
}
